<div class="content-section">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-div">
      <div
        class="col p-0 d-flex justify-content-between align-items-center changeInstitution"
      >
        <div class="col-11 p-0">
          <a class="back_bd" (click)='backToManageInstitution()'>
            <img class="svg mr-2" src="assets/ph-bhp-layout/svg/back.svg" />
            {{ translationKeys.SOPObservation.Back | translate}}</a
          >

          <h2 class="background_title">
            {{ 'WEBKESS_INTEGRATION.WEBKESS.DETAILS_1' | translate }}
          </h2>
        </div>
        <div
          class="col-auto d-flex justify-content-md-end justify-content-sm-start"
        >
          <div class="col-auto institution-name pl-0">
            <!-- <img alt="Institution" src="assets/img/svg/icon-help.svg"> -->
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
        <nav class="nav nav-pills nav-title d-none d-md-flex">
            <a class="nav-link" [routerLink]=institutionDetailTabs[0].url routerLinkActive='active'>{{ institutionDetailTabs[0].title | translate }}</a>
            <a *ngIf="(config.userData?.roleName.roleId !== 5) &&
            (config.userData?.roleName.roleId !== 1) &&
            (config.userData?.roleName.roleId !== 2) &&
            isPackageEnabled &&
            (institutionData?.institution.institution?.activateWebKess) &&
            ((institutionData?.institution.institution?.countryID == 3) ||
            (institutionData?.institution.institution?.countryID == 219) ||
            (institutionData?.institution.institution?.countryID == 15))" class="nav-link" [routerLink]=institutionDetailTabs[1].url routerLinkActive='active'>{{ institutionDetailTabs[1].title |
        translate}}</a>
            <a *ngIf="(config.userData?.roleName.roleId !== 5) &&
            (config.userData?.roleName.roleId !== 1) &&
            (config.userData?.roleName.roleId !== 2) &&
            isPackageEnabled &&
            (institutionData?.institution.institution?.activateWebKess) &&
            ((institutionData?.institution.institution?.countryID == 3) ||
            (institutionData?.institution.institution?.countryID == 219) ||
            (institutionData?.institution.institution?.countryID == 15))" class="nav-link" [routerLink]=institutionDetailTabs[2].url routerLinkActive='active'>{{ institutionDetailTabs[2].title |
        translate}}</a>
        </nav>
        <hr class="nav-separator">

        <div class="d-block d-md-none">
            <div class="btn-group btn-block customDropdown" dropdown>
                <button id="button-basic" dropdownToggle type="button" class="btn btn-muted btn-block dropdown-toggle" aria-controls="dropdown-basic">
          <!-- {{ButtonDropdown}} -->
        </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu btn-block customDropdownList" role="menu" aria-labelledby="button-basic">
                    <!-- <li role="menuitem"><a class="dropdown-item" href="#">Action</a></li> -->
                    <li role="menuitem active">
                        <a class="nav-link" routerLink='institution/view/:id/overview' routerLinkActive='active'>{{institutionDetailTabs[0].title | translate}}</a>
                    </li>
                    <li role="menuitem">
                        <a *ngIf="(config.userData?.roleName.roleId == 4) &&
            (institutionData?.institution.institution?.activateWebKess) &&
              ((institutionData?.institution.institution?.countryID == 3) ||
               (institutionData?.institution.institution?.countryID == 219) ||
                (institutionData?.institution.institution?.countryID == 15))" class="nav-link" routerLink=institutionDetailTabs[1].url routerLinkActive='active'>{{institutionDetailTabs[1].title |
              translate}}</a>
                    </li>
                    <li role="menuitem"><a *ngIf="(config.userData?.roleName.roleId !== 5) &&
            (institutionData?.institution.institution?.activateWebKess) &&
              ((institutionData?.institution.institution?.countryID == 3) ||
               (institutionData?.institution.institution?.countryID == 219) ||
                (institutionData?.institution.institution?.countryID == 15))" class="nav-link" routerLink=institutionDetailTabs[2].url routerLinkActive='active'>{{ institutionDetailTabs[2].title |
              translate}}</a></li>
                </ul>
            </div>
        </div>


    <div class="container-fluid page-content">
        <router-outlet></router-outlet>
    </div>
    </div>

  </div>
